import React, { useEffect, useState } from "react";
import handleChange from "../../hooks/handleChange";
import { useNavigate } from "react-router-dom";
import { login } from "../../util/http";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultLogin, setLoggedInUser, setLoggedOutUser, setLoginType, setSessionID } from "../../store/redux/login";
import "./Login.scss";
import ForgotPasswordForm from "../../components/ForgotPasswordForm/ForgotPasswordForm";
import NewPasswordForm from "../../components/NewPasswordForm/NewPasswordForm";
import GoogleAuthModal from "../../components/MFAModal/GoogleAuthModal";
import { getRequiredConstants, getSelectOptions } from "../../util/API/constants";
import { getDomainRoles } from "../../util/API/login";
import { setNewConstants, setRequiredConstants } from "../../store/redux/constants";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Box, Button, TextField, Checkbox, FormControlLabel, Switch, Autocomplete } from "@mui/material";
import VerifyCodeForm from "../../components/VerifyCodeForm/VerifyCodeForm";
import { getDeviceId } from "../../util/utilfunctions/utilFunctions";
import { setDeviceToken } from "../../store/redux/login";
import { countryAreaCode } from "../../constants/countrylist";
import { clearPreviousUsers } from "../../store/redux/previousUsers";
import { useMemo } from "react";
import mixpanel from '../../util/utilfunctions/mixpanel';

function Login() {
  const [userName, setUsername] = handleChange("");
  const [password, setPassword] = handleChange("");
  const [open, setOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(null);
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [resetPIN, setResetPIN] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordVisbile, setPasswordVisibility] = useState(false);
  const [userid, setUserid] = useState(null);
  const [verifyCode, setVerifyCode] = useState(false);
  const [newDevice, setNewDevice] = useState(false);
  const [deviceFP, setDeviceFP] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [hasAccessToPortal, setHasAccessToPortal] = useState(null);
  const [deviceAuthCredentials, setDeviceAuthCredentials] = useState(null);
  const [showSwitch, setShowSwitch] = useState(true);
  const [authenticatorCode, setAuthenticatorCode] = useState("");
  const [method, setMethod] = useState("email");
  const [countryCode, setCountryCode] = useState({
    value: "na",
    label: "Please select an area code",
    key: "na",
  });
  const [errorMessage, setErrorMessage] = useState("");

  let configVariables = useSelector((state) => state.config.baseConfig);
 
  const loginBackground = configVariables.loginBackground;
  const loginCardBackground = configVariables.loginCardBackground;
  const portalLogo = configVariables.logoURL
  // const portalLoginImage = useSelector((state) => state.config.config.photos.loginPicture);
  const currentYear = new Date().getFullYear();
  var allowedSecurityRoles = configVariables.allowed_security_roles;
  let isDevEnv = configVariables.devEnvironment;

  if (typeof allowedSecurityRoles === 'string') {
    allowedSecurityRoles = allowedSecurityRoles
      .split(',')
      .map(r => r.trim())
      .filter(Boolean);
  } else if (typeof allowedSecurityRoles === 'number') {
    allowedSecurityRoles = [allowedSecurityRoles.toString()];
  } else if (!Array.isArray(allowedSecurityRoles)) {
    allowedSecurityRoles = [];
  }

console.log("allowedSecurityRoles=========",allowedSecurityRoles);
  // useEffect(()=> {
  //   console.log("loginCardBackground============",loginCardBackground);
  // },[loginCardBackground])
 
  const resetFields = () => {
    setUsername({ target: { value: "" } });
    setPassword({ target: { value: "" } });
  };
 
  useEffect(() => {
    if (method === "email") {
      setCountryCode({
        value: "na",
        label: "Please select an area code",
        key: "na",
      });
    }
  }, [method]);
 
  const toggleMethod = () => {
    setMethod((prev) => (prev === "email" ? "mobile" : "email"));
  };
 
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    dispatch(setLoggedOutUser());
  };

  const decodeHtmlEntities = (str) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  };
 
  const toggleRecovery = () => {
    setRecoverPassword(!recoverPassword);
    setLoggedIn(null);
    resetFields();
  };
 
  const toggleVerificationCode = () => {
    verifyCode ? setVerifyCode(false) : setVerifyCode(true)
    setNewDevice(false);
    setLoggedIn(null);
    resetFields();
  }
 
  const toggleReset = () => {
    setResetPassword(!resetPassword);
    setVerifyCode(false)
    setLoggedIn(null);
    resetFields();
  };
 
  const togglePassVisibility = () => {
    setPasswordVisibility(!passwordVisbile);
  };
 
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  useEffect(() => {
    const storedUsername = localStorage.getItem("rememberedUsername");
    if (storedUsername) {
      setUsername({ target: { value: storedUsername } });
      setRememberMe(true);
    }
  }, []);
 
  async function handleFormSubmit(e) {
    setAuthenticatorCode("");
    try{
      e.preventDefault();
    } catch (error) {
 
    }
    setLoading(true);
    setErrorMessage('');
    let deviceID = localStorage.getItem('deviceID');
    if (!deviceID) {
      deviceID = await getDeviceId();
      localStorage.setItem("deviceID", deviceID);
      setDeviceFP(deviceID);
    }
    const viewID = crypto.randomUUID();
    let response = await login(userName, password, deviceID, viewID, method, countryCode?.value?.replace("+", ""));
    let callStatus = response?.callStatus;

    console.log("logninResponse-----------",response);

    if (!response) {
      setErrorMessage("Unable to reach the Portal backend. Check the local backend target and try again.");
      setLoading(false);
      return;
    }
 
    setUserid(response.userid);
 
    if (callStatus == 1) {

      // ======== Check for allowed roles from config and accordingly allow user to login. =========
      const hasWildcard = allowedSecurityRoles.includes('*');
      const userRoles = response?.payload?.body?.Securityuserrole;
      const userRolesArray = Array.isArray(userRoles) ? userRoles : [userRoles];
      const userRoleIds = userRolesArray
      .map(role => role?.roleid?.toString())
      .filter(Boolean);
      // Check if there's any match between userRoleIds and allowedSecurityRoles
      const hasMatch = hasWildcard || userRoleIds.some(roleId => allowedSecurityRoles.includes(roleId));

      if (hasMatch) {
        console.log("Matched");
      } else {
        setHasAccessToPortal(false);
        setLoading(false);
        return;
      }
      // ================================================================================================

      dispatch(setDefaultLogin(userName));
      dispatch(setLoginType(method));
      if (method === "mobile") {
        setUsername({ target: { value: `${countryCode?.value?.replace("+", "")}${userName}@4pay.ph` } });
      }
      // Check if user has access to the portal, if not authorized then stop the login prossess.
      // let allowedRoles = await getDomainRoles("PORTALROLES");
      // if(allowedRoles?.data?.header?.callStatus == "1") {
      //   const securityUserRole = response?.payload?.body?.Securityuserrole;
 
      //   const userAssignedRoles = Array.isArray(securityUserRole)
      //     ? securityUserRole.map((role) => role.roleid) // Extract roleid from each object
      //     : [securityUserRole?.roleid]; // Handle the case when it's a single object
        
      //   const allowedRolesArr = allowedRoles?.data?.body?.DomainAttributes?.record || [];
      //   const hasAccess = userAssignedRoles.some((userRole) =>
      //     allowedRolesArr.some((role) => role.DomainAttribute.domainatt === userRole)
      //   );
 
      //   if (!hasAccess) {
      //     setHasAccessToPortal(false);
      //     setLoading(false);
      //     return;
      //   }
      // }
 
      dispatch(setDeviceToken(deviceID));
      let sessionID = response.sessionID;
      localStorage.setItem("authUser", response.userid);
      localStorage.setItem("sessionID", sessionID);
      dispatch(setSessionID(sessionID));
      let passwordRequireChange =
        response.payload.body.User.passwordRequireChange;
 
      console.log("pinRequireChange============", response.payload.body.User);
      let pinRequireChange = response.payload.body.User.PINChangedDate == "" ? "1" : response.payload.body.User.PINRequireChange;
      // let pinRequireChange = response.payload.body.User.PINRequireChange;
        const accessList = response?.access
          ? Array.isArray(response.access)
            ? response.access
            : [response.access]
          : [];
 
          const roleList = response?.payload?.body?.Securityuserrole
          ? Array.isArray(response?.payload?.body?.Securityuserrole)
            ? response?.payload?.body?.Securityuserrole
            : [response?.payload?.body?.Securityuserrole]
          : [];

      console.log("pinRequireChange???============", pinRequireChange);
      
      if (pinRequireChange === "1") {
        setResetPIN(true);
      }
      
      if (passwordRequireChange != 0) {
        setResetPassword(true);
      } else {
        // let firstViablePath = response?.payload?.body?.Securityuserrole?.roleid == '844' ? 'reporting' : "crm"
      //  let firstViablePath = (response?.payload?.body?.Securityuserrole?.roleid === configVariables.payRollAdminId) ? "payrollbatch" : (response?.payload?.body?.Securityuserrole?.roleid === configVariables.portfolioAdminId) ? "portfolio" : (response?.payload?.body?.Securityuserrole?.roleid == '844' || response?.payload?.body?.Securityuserrole?.roleid == '707') ? 'reporting' : (response?.payload?.body?.Securityuserrole?.roleid == '845') ? "loans" : "crm";        // let firstViablePath = "crm"

      let rolesRaw = response?.payload?.body?.Securityuserrole;

      let rolesArr = Array.isArray(rolesRaw)
        ? rolesRaw
        : rolesRaw
        ? [rolesRaw]
        : [];

      // let roleId = String(response?.payload?.body?.Securityuserrole?.roleid);
      let roleIdsVar = rolesArr.map(r => String(r.roleid));
      console.log("roleIdsVar===========",roleIdsVar);

      let payRollIds = String(configVariables.payRollAdminId)
        .split(',')
        .map(id => id.trim());
       let associatepayRollIds = String(configVariables.associatePayrollAdminId)
        .split(',')
        .map(id => id.trim());
        console.log('associatepayRollIds------->', associatepayRollIds)
      let portfolioIds = Array.isArray(configVariables.portfolioAccessIds)
        ? configVariables.portfolioAccessIds.map(String)
        : String(configVariables.portfolioAccessIds)
            .split(',')
            .map(id => id.trim());
      let arcComputeAdminId = String(configVariables.arcComputeAdminId).split(',').map(id => id.trim());

      let firstViablePath =
        roleIdsVar.some(id => payRollIds.includes(id) || associatepayRollIds.includes(id))
          ? "payrollbatch"
          : roleIdsVar.some(id => portfolioIds.includes(id))
          ? "portfolio"
          : roleIdsVar.some(id => arcComputeAdminId.includes(id))
          ? "DeepDD"
          : roleIdsVar.some(id => id === '844' || id === '707')
          ? "reporting"
          : roleIdsVar.some(id => id === '845')
          ? "loans"
          : "crm";
        
        dispatch(setLoggedInUser(response));
        let selectOptions = await getSelectOptions();
        let requiredOptions = await getRequiredConstants();
 
        const roles = roleList.flatMap((role) =>
          requiredOptions?.SystemRoles?.filter(
            (systemRole) => systemRole?.securityrole?.roleid === role?.roleid
          )
        );
 
        // const checkAssociateAdmin = roles.some((role) =>
        //   /(associate\s+admin|h\/o\s+backend)/i.test(role?.securityrole?.name)
        // );
 
 
        // const checkAdmin = roles.some((role) =>
        //   /(admin|h\/o\s+backend)/i.test(role?.securityrole?.name)
        // );
 
        // const checkAssociateAdmin = !checkAdmin && roles.some((role) =>
        //   /\bassociate\s+admin\b/i.test(role?.securityrole?.name)
        // );
 
        // Strict match: Only matches 'admin', not 'associate admin'
        const isStrictAdmin = roles.some((role) =>
          /^ncs\s+admin$/i.test(role?.securityrole?.name)
        );
 
        // Associate admin only if not already strict admin
        const checkAssociateAdmin = !isStrictAdmin && roles.some((role) =>
          /^ncs\s+associate\s+admin$/i.test(role?.securityrole?.name)
        );
 
        const isGenericAssociateLikeAdmin = !isStrictAdmin && roles.some((role) => {
          const roleName = role?.securityrole?.name?.toLowerCase();
          return /\badmin\b/.test(roleName) && !/^ncs\s+admin$/.test(roleName) && !/^ncs\s+associate\s+admin$/.test(roleName);
        });

        // Combined admin permission (strict admin OR associate admin)
        const checkAdmin = isStrictAdmin || checkAssociateAdmin || isGenericAssociateLikeAdmin || response?.payload?.body?.Securityuserrole?.roleid == "844" || response?.payload?.body?.Securityuserrole?.roleid == "707";
        
        const checkSuperAdmin = roles.some((role) =>
          /super\s+admin/i.test(role?.securityrole?.name)
        );
 
        const checkSuperAgent = roles.some((role) =>
          /super\s+agent/i.test(role?.securityrole?.name)
        );
        
        const checkOperator = roles.some((role) =>
          /operator/i.test(role?.securityrole?.name)
        );
 
        const checkAssociateAgent = roles.some((role) =>
          /associate\s+agent/i.test(role?.securityrole?.name)
        );
 
        const checkLoanAdmin = roles.some((role) =>
          /loan\s+admin/i.test(role?.securityrole?.name)
        );

        const checkAgent = roles.some((role) =>
          /agent/i.test(role?.securityrole?.name)
        );

        dispatch(setNewConstants({ formSelectData: selectOptions }));
        console.log("requiredOptions===============",requiredOptions);
        dispatch(setRequiredConstants({ requiredOptions }));
        sessionStorage.setItem("userResponse", JSON.stringify(response));
        sessionStorage.setItem("parentuserid", response.parentuserid);
        sessionStorage.setItem("parentuserid", response.parentuserid);
        sessionStorage.setItem("isAdmin", checkAdmin);
        sessionStorage.setItem("isOperator", checkOperator);
        sessionStorage.setItem("isSuperAdmin", checkSuperAdmin);
        sessionStorage.setItem("isAssociateAgent", checkAssociateAgent);
        sessionStorage.setItem("isSuperAgent", checkSuperAgent);
        sessionStorage.setItem("isAssociateAdmin", checkAssociateAdmin);
        sessionStorage.setItem("isLoanAdmin", checkLoanAdmin);
        sessionStorage.setItem("isAgent", checkAgent);
        console.log("login_userSecurityRoleId===========",response?.payload?.body?.Securityuserrole);

        // New code added by Prat for HoltEx
        let rolesVar = response?.payload?.body?.Securityuserrole;
        let rolesArray = Array.isArray(rolesVar) ? rolesVar : rolesVar ? [rolesVar] : [];
        // Extract all role IDs
        let roleIds = rolesArray.map(r => r.roleid);
        // Convert to comma-separated string
        let roleIdsString = roleIds.join(",");
        // Store in sessionStorage
        if (roleIdsString) {
            sessionStorage.setItem("userSecurityRoleId", roleIdsString);
        }

        // sessionStorage.setItem("userSecurityRoleId", response?.payload?.body?.Securityuserrole?.roleid);
        // sessionStorage.setItem("isStrictAdmin", isStrictAdmin);
        sessionStorage.setItem("viewID", viewID);
 
 
        if (rememberMe) {
          localStorage.setItem("rememberedUsername", userName);
        } else {
          localStorage.removeItem("rememberedUsername");
        }
 
        dispatch(clearPreviousUsers());
 
        //This is how I bypass MFA, instead of going to the MFA flow, I add the user details and go straight to the portal
        if (
          userName == "paiyadmin@4pay.ca" ||
          // userName == "paiyadmin1@4pay.ca" ||
          userName == "ransfordhewitt@4pay.ca" ||
          userName == "ncsagent@4pay.ca" ||
          userName == "clerk.john279" ||
          userName == "ncslo1@4pay.ca" ||
          // userName == "newncsadmin@4pay.ca" ||
          userName == "newheadoffice@4pay.ca" ||
          userName == "ncssuperadmin@4pay.ca" ||
          userName == "newncsadmin@4pay.ca" ||
          userName == "ncsadminqa1@4pay.ca" ||
          userName == "ncshoqa@4pay.ca" ||
          userName == "ncsagentqa@4pay.ca" ||
          userName == "clerk.qa82" ||
          userName == "ncsadmin@4pay.ca" ||
          userName == "ncsagentqa@4pay.ca" ||
          userName == "ncsoperatorqa@4pay.ca" ||
          userName == "ncsheadofficeqa@4pay.ca" ||
          userName == "ncsbranch@4pay.ca" ||
          userName == "counter1.11135" ||
          userName == "loanreporter@4pay.ca" ||
          userName == "ncspaiyhoqa@4pay.ca" ||
          userName == "ncsadmin1@4pay.ca" ||
          userName == "branch1@4pay.ca" ||
          userName == "testho@4pay.ca" ||
          userName == "clerk.test89" ||
          userName == "associateagent1@4pay.ca" ||
          userName == "associateagentqa1@4pay.ca" ||
          userName == "newassociate11@4pay.ca" ||
          userName == "adminqa2@4pay.ca" ||
          userName == "paiyadmin1@4pay.ca" ||
          userName == "associatebranch1@4pay.ca" ||
          userName == "john.g16" ||
          userName == "paiydemo1@4pay.ca" ||
          userName == "tedpaiyuser@4pay.ca" ||
          userName == "earlpaiyuser@4pay.ca" ||
          userName == "abelpaiyuser@4pay.ca" ||
          userName == "brandonpaiyuser@4pay.ca" ||
          userName == "gautampaiyuser@4pay.ca" ||
          userName == "danepaiyuser@4pay.ca" ||
          userName == "admin1@4pay.ca" ||
          userName == "Suadmin01@4pay.ca" ||
          userName == "testmerchant@4pay.ca" ||
          userName == "Paiyqaadmin@4pay.ca" ||
          userName == "newagent1@4pay.ca" ||
          // userName == "givir92957@ofular.com" ||
          userName == "ncssuperagent@4pay.ca" ||
          userName == "439uou86ps@knmcadibav.com" ||
          userName == "diyive5571@boxmach.com" ||
          userName == "superho1@4pay.ca" ||
          userName == "superadmin2@4pay.ca" ||
          userName == "Suadmin02@4pay.ca" ||
          userName == "sonih10185@pacfut.com" ||
          userName == "demoadmintest@4pay.ca" ||
          userName == "testagentnew@4pay.ca" ||
          userName == "aclerk1@4pay.ca" ||
          userName == "aclerk1@4pay.ca" ||
          userName == "ncsheadoffice@4pay.ca" ||
          // userName == "accountinclerk@4pay.ca" ||
          userName == "paiykuikagent1@4pay.ca" ||
          response?.isMFAExempted == true
        ) {
          sessionStorage.setItem("user", JSON.stringify(response));
          setLoggedIn(false);
          console.log("Successfully Logged In----------------",response?.payload?.body);
          mixpanel.track('User Logged In', {
            plan: 'Free',
            source: 'Landing Page',
          });

          mixpanel.identify(response?.payload?.body?.User?.id);

          mixpanel.people.set({
            $email: response?.payload?.body?.Useremailaccount?.emailAccount,
            $name: `${response?.payload?.body?.User?.firstName} ${response?.payload?.body?.User?.lastName}`,
          });

          navigate(`/${firstViablePath}`, { replace: true });
        } else {
          handleOpen();
        }
      }
    } else {
      setErrorMessage(response?.payload?.msg);
      if (response?.payload?.errorNo === "10002-8") {
        console.log("loginResponse2-----------------",response);
        // ======== Check for allowed roles from config and accordingly allow user to login. =========
        const hasWildcard = allowedSecurityRoles.includes('*');
        const userRoles = response?.securityuserrole;
        const userRolesArray = Array.isArray(userRoles) ? userRoles : [userRoles];
        const userRoleIds = userRolesArray
        .map(role => role?.roleid?.toString())
        .filter(Boolean);
        // Check if there's any match between userRoleIds and allowedSecurityRoles
        const hasMatch = hasWildcard || userRoleIds.some(roleId => allowedSecurityRoles.includes(roleId));

        if (hasMatch) {
          console.log("Matched");
        } else {
          setHasAccessToPortal(false);
          setLoading(false);
          return;
        }
        // ================================================================================================
        console.log("new user device");
        const userid = response.payload.user.id;
        setUserid(userid);
        setNewDevice(true);
        setVerifyCode(true);
        if (method === "mobile") {
          setUsername({ target: { value: `${countryCode?.value?.replace("+", "")}${userName}@4pay.ph` } });
        }
        // helps to check with clerk b/c of @4pay.me account
        if (!userName.includes("@")) {
          setShowSwitch(false);
        }
        setDeviceAuthCredentials({
          username: userName,
          altEmail: response.payload.user.other1,
          phone: response.payload.user.telephoneno,
          country: response.payload.user.countryid
        });
      }
      console.log("Successfully logged in------------------");
      setLoggedIn(true);
    }
    setLoading(false);
  }
 
  const backgroundImage = loginBackground
    ? { backgroundImage: `url(${loginBackground})` }
    : {};

  // const backgroundCardImage = {
  //   backgroundImage: `url(${loginCardBackground}?version=${new Date().getTime()})`,
  // };
  
  // const backgroundCardImage = useMemo(() => ({
  //   backgroundImage: `url(${loginCardBackground}?version=${new Date().getTime()})`,
  // }), [loginCardBackground]);

  const backgroundCardImage = loginCardBackground
    ? { backgroundImage: `url(${loginCardBackground})` }
    : {};
 
  console.log(countryCode)
 
  return (
    <Box className="login-container" style={backgroundImage}>
      <GoogleAuthModal
        open={open}
        onClose={handleClose}
        setLoggedIn={setLoggedIn}
        authenticatorCode={authenticatorCode}
        setAuthenticatorCode={setAuthenticatorCode}
      />
      <Box className="login-box">
        {/* <Box className="left-box" style={backgroundCardImage}>
          <Box class="login-user-image">
            <img src={portalLoginImage} loading="lazy" />
          </Box>
          <Box className={configVariables.logoCSS}>{decodeHtmlEntities(configVariables.portalName)}</Box>
          {configVariables.devEnvironment && <Box className="login-subtitle">
            Please use your credentials to login.
          </Box> }
        </Box> */}
        <Box className={isDevEnv ? `right-box` : `right-box new-bg`}>
          <Box className="sendit-logo">
            {portalLogo && (
              <img style={{ maxHeight: "100px", maxWidth: "400px" }} src={portalLogo} loading="lazy" alt="Portal" />
            )}
          </Box>
 
          {recoverPassword ? (
            //Recovery Password Form
            <ForgotPasswordForm toggleRecovery={toggleRecovery} />
          ) : resetPassword ? (
            //Reset Password
            <NewPasswordForm toggleReset={toggleReset} userName={userName} userid={userid} resetPIN={resetPIN} />
          ) :
          verifyCode ?
          <VerifyCodeForm toggleVerify={toggleVerificationCode} newDevice={newDevice} userid={userid || ''} username={userName} handleLogin={handleFormSubmit} deviceToken={deviceFP} deviceAuthCredentials={deviceAuthCredentials} showSwitch={showSwitch} method={method} />
          : (
            <Box>
              <Box className="login-label">Login</Box>
              {configVariables.devEnvironment && <Box sx={{mb: 2}}>
                <span style={{ marginRight: 8, fontWeight: method === "email" ? "bold" : "normal" }}>Email</span>
                <Switch
                  checked={method === "mobile"}
                  onChange={toggleMethod}
                  color="primary"
                />
                <span style={{ marginLeft: 8, fontWeight: method === "mobile" ? "bold" : "normal" }}>Mobile</span>
              </Box>}
              <form onSubmit={handleFormSubmit}>
                <Box>
                {method === "mobile" && (
                  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <Autocomplete
                      options={countryAreaCode}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField {...params} label="Country Code" />
                      )}
                      value={countryCode}
                      onChange={(e, value) => setCountryCode(value)}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      sx={{ width: "425px" }}
                    />
                  </Box>
                )}
 
                  <TextField
                    className="login-input"
                    name="username"
                    value={userName}
                    onChange={setUsername}
                    label={method === "email" ? "Email" : "Mobile Number"}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
                <div className="password-container">
                  <TextField
                    className="login-input"
                    name="password"
                    value={password}
                    onChange={setPassword}
                    label="Password"
                    type={passwordVisbile ? "text" : "password"}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                  <span onClick={togglePassVisibility} className="visible-icon">
                    {passwordVisbile ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
 
                <Box className="remember-me-container">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                    }
                    label="Remember Me"
                  />
                </Box>
 
                {loggedIn && (
                  <Box id="failed-login" className="mb-3">
                    {errorMessage}
                  </Box>
                )}
 
                {
                  hasAccessToPortal == false && (
                    <Box id="failed-login" className="mb-3">
                      Unauthorized Access
                    </Box>
                  )
                }
 
                <Box className="login-button-container">
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      className="forgot-password-text pointer"
                      onClick={toggleRecovery}
                    >
                      Forgot Password?
                    </Box>
                  
                    <Box
                      className="forgot-password-text pointer"
                      onClick={toggleVerificationCode}
                    >
                      Verify your Account
                    </Box>
                  </Box>
                  <Box>
                    <Button
                      className={`login-button ${
                        loading ? "btn-disabled" : ""
                      }`}
                      disabled={loading}
                      type="submit"
                    >
                      LOGIN
                    </Button>
                  </Box>
                </Box>
              </form>
              <Box>
                <Box className="pay-message">
                  Powered by <span className="pay-bold">4PAY</span>
                  <br />© {currentYear} 4PAY. All rights reserved.
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
 
      <Box className="login-warning pt-3">
        By logging into this portal, you agree to use it only for authorized
        purposes. You are responsible for keeping your account information
        confidential and for all activities on your account. Your use of this
        portal signifies your agreement with our Privacy Policy on data
        handling. Be aware that this portal is monitored
      </Box>
    </Box>
  );
}
 
export default Login;
